import React from 'react';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import './page-header.scss';

function PageHeader(props) {
  return (
    <div
      className={`page-header ${props.bgImageHide ? 'bg-hide' : ''} theme-${
        props.theme
      }`}
      style={
        props.bgImageHide
          ? null
          : {
              backgroundImage: `url(${props.PagaHeaderBg })`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
            }
      }
    >
      {props.bgImageHide ? null : (
        <div
          className="page-header-overlay"
          style={props.overlay ? { backgroundColor: props.overlay } : null}
        ></div>
      )}
      <div className="page-header-wrapper">
        <Container>
          <Row className="d-flex justify-content-start">
            <div className={props.colSize || 'col-md-8'}>
              <div className="page-header-inner">
                {props?.breadCrumbItems && (
                  <ul className="page-breadcrumbs">
                    {props.breadCrumbItems.map((item, index) => {
                      return item.active ? (
                        <li key={index} className="breadcrumb-item active">
                          {item.label}
                        </li>
                      ) : (
                        <li key={index} className="breadcrumb-item">
                          <Link to={item.path}>{item.label}</Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
                <div className="page-header-title first-letter-capitalize">{props.title}</div>
                {props?.description && <p>{props.description}</p>}
                
              </div>
            </div>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default PageHeader;
